module.exports = __webpack_public_path__ + "img/e759385.png";